import { TbTruckDelivery, TbMessages } from "react-icons/tb";
import { MdPayments, MdSupportAgent } from "react-icons/md";

export const Features = () => {
  return (
    <div
      className="Features my-8 px-2 lg:px-20 lg:gap-8 grid grid-cols-1 lg:grid-cols-4 md:grid-cols-2 w-full justify-center items-center gap-2"
    >
      <div className="Service grid grid-cols-2 justify-items-center bg-white drop-shadow-md hover:drop-shadow transition rounded-lg p-2">
        <div className="imgBox w-12">
          <TbTruckDelivery className="w-full h-full text-primary" />
        </div>
        <div className="info flex flex-col items-center justify-evenly">
          <h3 className="text-base text-gray-800 font-Roboto font-medium">
            World
          </h3>
          <p className="text-sm text-gray-400 font-Roboto font-medium">
            Shopping
          </p>
        </div>
      </div>
      <div className="Service grid grid-cols-2 justify-items-center bg-white drop-shadow-md hover:drop-shadow transition rounded-lg p-2">
        <div className="imgBox w-12">
          <TbMessages className="w-full h-full text-primary" />
        </div>
        <div className="info flex flex-col items-center justify-evenly">
          <h3 className="text-base text-gray-800 font-Roboto font-medium">
            99% Customer
          </h3>
          <p className="text-sm text-gray-400 font-Roboto font-medium">
            Feedback
          </p>
        </div>
      </div>
      <div className="Service grid grid-cols-2 justify-items-center bg-white drop-shadow-md hover:drop-shadow transition rounded-lg p-2">
        <div className="imgBox w-12">
          <MdPayments className="w-full h-full text-primary" />
        </div>
        <div className="info flex flex-col items-center justify-evenly">
          <h3 className="text-base text-gray-800 font-Roboto font-medium">
            Payment
          </h3>
          <p className="text-sm text-gray-400 font-Roboto font-medium">
            Secured system
          </p>
        </div>
      </div>
      <div className="Service grid grid-cols-2 justify-items-center bg-white drop-shadow-md hover:drop-shadow transition rounded-lg p-2">
        <div className="imgBox w-12">
          <MdSupportAgent className="w-full h-full text-primary" />
        </div>
        <div className="info flex flex-col items-center justify-evenly">
          <h3 className="text-base text-gray-800 font-Roboto font-medium">
            24/7 Support
          </h3>
          <p className="text-sm text-gray-400 font-Roboto font-medium">
            Helpline - 123
          </p>
        </div>
      </div>
    </div>
  );
};
